import DeletedIcon from 'gcs-common/img/account_deletion.svg?react';
import styles from './styles.module.scss';

const VideoDeleted = () => {
  return (
    <div className={styles.videoDeletedContainer}>
      <DeletedIcon alt="video-deleted" className={styles.videoDeletedIcon} />
      <p>das Video ist nicht mehr verfügbar</p>
    </div>
  );
};

export default VideoDeleted;

VideoDeleted.propTypes = {};
